module.exports = __webpack_public_path__ + "img/shutan.d50b33bd.png";